<template>
  <div class="home" ref="home">

	<AiHoverBtn v-if="firstCardData" />	

	<!-- <div class="markdownContent" style="padding: 50px;">
		<div v-html="displayedContent" style=""></div>
	</div> -->
    <!-- <HomeTop ref="hometop" :topData="topData" :healthBigData="healthBigData" /> -->
	<FirstCard :style="{zIndex: isTip && tipType == 1 ? 10000 : 0}" style="" ref="rank" :isTip="isTip && tipType == 1" :data="firstCardData" @skippingTutorial="skippingTutorial" @next="next" :dataLength="firstCardDataLength" :emptyString="(firstCardDict && firstCardDict.timelyCareElderTips) ? firstCardDict.timelyCareElderTips : ''" />
	<SecondCard :style="{zIndex: isTip && tipType == 2 ? 10000 : 0}" ref="rank" :isTip="isTip && tipType == 2" :data="secondCardData" @skippingTutorial="skippingTutorial" @next="next" :dataLength="secondCardDataLength" :emptyString="(secondCardDict && secondCardDict.longObserveElderTips) ? secondCardDict.longObserveElderTips : ''" />
	<FourthCard :style="{zIndex: isTip && tipType == 3 ? 10000 : 0}" ref="rank" :isTip="isTip && tipType == 3" :data="rankingListData" @skippingTutorial="skippingTutorial" @next="next" />
	<!-- <ThirdCard v-if="thirdCardData && thirdCardDataLength > 0" ref="rank" :data="thirdCardData" :dataLength="thirdCardDataLength" /> -->
    <!-- <BjThing ref="bjThing" :bjAllData="bjAllData"/> -->
    <!-- <Rank ref="rank" :rankListData="rankListData"/> -->
    <!-- <Star ref="star" :healthBigData="healthBigData" v-if="healthBigData[3].enable == 1"/>
    <Fall ref="fall" :healthBigData="healthBigData" v-if="healthBigData[3].enable == 1"/>
    <HomeBottom ref="homeBottom" :healthBigData="healthBigData"  v-if="healthBigData[4].enable == 1 || healthBigData[5].enable == 1"/> -->
    <!-- <OldmanState ref="OldmanState" :healthBigData="healthBigData" @open_tan_needGZ_single="open_tan_needGZ_single" /> -->
    <Healthy ref="healthy" />
    <div style="height: 0px;"></div>

    
    
    
    

    <!-- 弹窗_关注老人单人详情 -->
    <tan_needGz_sin ref="tan_needGz_sin"></tan_needGz_sin>

	<div v-if="isTip && tipType > 0" style="position: fixed; background: rgba(33, 35, 37, 0.3); z-index: 1000; top: 0px; bottom: -100px; left: 0px; right: 0px; "></div>

  </div>
</template>

<script>
import HomeTop from './component/homeTop.vue';
import FirstCard from './component/firstCard.vue';
import SecondCard from './component/secondCard.vue';
import ThirdCard from './component/thirdCard.vue';
import FourthCard from './component/fourthCard.vue';
import BjThing from './component/bjThing.vue';
import Rank from './component/rank.vue';                   
import OldmanState from './component/oldmanState.vue';      //老人状态
import Star from './component/star.vue';
import Fall from './component/fall.vue';
import HomeBottom from './component/homeBottom';
import Global from '../../utils/global';
import Healthy from '../../component/healthy/healthy.vue';

import tan_needGz_sin from './component/tan_needGz_sin.vue';      //弹窗_关注老人单人详情

import thirdCardMockData from './thirdCardMockData.json'

import dataJson from './component/aaa.json'

import AiHoverBtn from './aiHoverBtn.vue'

export default {
  components: { HomeTop, BjThing, Rank, OldmanState, Star, Fall, HomeBottom, Healthy,tan_needGz_sin, FirstCard, SecondCard, ThirdCard, FourthCard, AiHoverBtn},
  data() {
    return {
      topData: {},
      healthBigData: [
        { enable: 0 },
        { enable: 0 },
        { enable: 0 },
        { enable: 0 },
        { enable: 0 },
        { enable: 0 },
        { enable: 0 },
      ],
      tenantId: null,



      // 新加
      bjAllData: null,        //获取首页报警事件接口
      rankListData: null,     //查看首页排行榜接口

	  // 当日需及时关心的长者
	  firstCardDict: null,
	  firstCardData: null,
	  firstCardDataLength: 0,

	  // 需要长期观察的长者
	  secondCardDict: null,
	  secondCardData: null,
	  secondCardDataLength: 0,

	  // 状态优秀的长者
	  thirdCardData: null,
	  thirdCardDataLength: 0,

	  // 排行榜
	  rankingListData: null,

	  isTip: false,
	  tipType: 0, // 1-卡片一 2-卡片二 3-卡片三
	  tempA: '',
	  tempB: '',
	  rawContent: '### 总览：\n- **长者人数**：今天需要关注8位长者。\n- **主要事件**：\n  - **北床周公英（1楼-3层-301房）**：呼吸率变快；发生1次呼吸过速报警。\n  - **南床赵国策（1楼-1层-108房）**：睡眠破碎；发生1次呼吸过速报警。\n  - **南床汪明纲（2楼-5层-502房）**：发生15次呼吸过速报警。\n  - **北床赵淑敏（1楼-3层-310房）**：发生7次呼吸过速报警。\n  - **南床刘桂英（1楼-2层-206房）**：发生3次呼吸过速报警。\n  - **西床颜秀梅（1楼-1层-113房）**：发生2次呼吸过速报警。\n  - **南床杨玉兰（1楼-1层-106房）**：入睡时间比日常晚、入睡时长变长。\n  - **北6赵吉良（1楼-3层-315房）**：吸呼比变高。\n\n### 报警集中时间段：\n今天发生的呼吸过速报警事件主要集中在夜间（20:18～22:16）和下午（14:55～16:00）。建议在这两个时间段内：\n- 加强观察，特别是在14:55～16:00期间增加查房频次，必要时给予辅助睡眠措施。\n- 在夜间时段（20:18～22:16）期间，注意是否有活动后疲劳或不适的迹象，并相应调整护理措施。\n\n### 具体信息：\n\n#### 1. 北床周公英（1楼-3层-301房）\n- **事件**：呼吸率变快；发生1次呼吸过速报警。\n- **具体数据**：\n  - **9月4日**：呼吸率为25bpm。\n  - 23:00～23:02 发生1次呼吸过速报警。\n- **护理措施建议**：\n  - 沟通身体情况。\n  - 了解睡前饮食用药情况。\n  - 进行基础的体温、血压、呼吸、心跳测量。\n- **科普讲解**：\n  - **呼吸率变快**：呼吸频率高于日常表现范围，提示可能存在呼吸系统问题。\n  - **呼吸过速**：呼吸频率超过设置的报警阈值。成人正常呼吸频率一般为8～22次/分钟。呼吸过速可能是由于焦虑、发热、心脏疾病等原因引起。\n\n#### 2. 南床赵国策（1楼-1层-108房）\n- **事件**：睡眠破碎；发生1次呼吸过速报警。\n- **具体数据**：\n  - **9月4日**：呼吸过速报警 09:30～09:31 发生1次。\n  - **睡眠破碎**：9月4日睡眠破碎指数为90。\n- **护理措施建议**：\n  - 沟通身体情况。\n  - 了解情绪情况。\n  - 睡前饮食用药情况。\n  - 进行基础的体温、血压、呼吸、心跳测量。\n  - 提供理疗等放松类服务。\n- **科普讲解**：\n  - **睡眠破碎**：即在夜间睡眠过程中频繁醒来或长时间处于浅睡状态，导致无法获得连续的高质量睡眠。这种情况会导致第二天感到疲倦、注意力不集中等问题。睡眠破碎不同于整夜无眠，而是指在睡眠周期内多次中断，影响了正常的深度睡眠和REM（快速眼动）睡眠阶段。\n\n#### 3. 南床汪明纲（2楼-5层-502房）\n- **事件**：发生15次呼吸过速报警。\n- **具体数据**：\n  - **9月4日**：\n    - 00:05～00:06 发生1次呼吸过速报警。\n    - 00:10～00:10 发生1次呼吸过速报警。\n    - 01:06～01:08 发生1次呼吸过速报警。\n    - 01:09～01:09 发生1次呼吸过速报警。\n    - 20:18～20:20 发生1次呼吸过速报警。\n    - 20:29～20:29 发生1次呼吸过速报警。\n    - 20:31～20:32 发生1次呼吸过速报警。\n    - 20:34～20:35 发生1次呼吸过速报警。\n    - 20:37～20:37 发生1次呼吸过速报警。\n    - 21:23～21:26 发生1次呼吸过速报警。\n    - 21:34～21:50 发生1次呼吸过速报警。\n    - 21:55～21:55 发生1次呼吸过速报警。\n    - 21:57～22:06 发生1次呼吸过速报警。\n    - 22:08～22:16 发生1次呼吸过速报警。\n    - 23:55～23:57 发生1次呼吸过速报警。\n- **集中报警时间**：\n  - 夜间时段（20:18～22:16）。\n- **护理措施建议**：\n  - 夜间时段（20:18～22:16）增加观察频次，必要时给予辅助睡眠措施。\n  - 沟通身体情况。\n  - 进行基础的体温、血压、呼吸、心跳测量。\n  - 结合实际情况适当调高报警阈值。\n- **科普讲解**：\n  - **呼吸过速**：呼吸频率超过设置的报警阈值。成人正常呼吸频率一般为8～22次/分钟。呼吸过速可能是由于焦虑、发热、心脏疾病等原因引起。\n\n#### 4. 北床赵淑敏（1楼-3层-310房）\n- **事件**：发生7次呼吸过速报警。\n- **具体数据**：\n  - **9月4日**：\n    - 04:02～04:03 发生1次呼吸过速报警。\n    - 14:55～14:56 发生1次呼吸过速报警。\n    - 15:06～15:09 发生1次呼吸过速报警。\n    - 15:18～15:18 发生1次呼吸过速报警。\n    - 15:47～15:47 发生1次呼吸过速报警。\n    - 15:55～15:55 发生1次呼吸过速报警。\n    - 15:59～16:00 发生1次呼吸过速报警。\n- **集中报警时间**：\n  - 下午时段（14:55～16:00）。\n- **护理措施建议**：\n  - 下午时段（14:55～16:00）加强监测，关注是否与活动后疲劳有关。\n  - 沟通身体情况。\n  - 进行基础的体温、血压、呼吸、心跳测量。\n  - 结合实际情况适当调高报警阈值。\n- **科普讲解**：\n  - **呼吸过速**：呼吸频率超过设置的报警阈值。成人正常呼吸频率一般为8～22次/分钟。呼吸过速可能是由于焦虑、发热、心脏疾病等原因引起。\n\n#### 5. 南床刘桂英（1楼-2层-206房）\n- **事件**：发生3次呼吸过速报警。\n- **具体数据**：\n  - **9月4日**：\n    - 08:59～08:59 发生1次呼吸过速报警。\n    - 11:48～11:50 发生1次呼吸过速报警。\n    - 12:58～13:01 发生1次呼吸过速报警。\n- **护理措施建议**：\n  - 沟通身体情况。\n  - 进行基础的体温、血压、呼吸、心跳测量。\n- **科普讲解**：\n  - **呼吸过速**：呼吸频率超过设置的报警阈值。成人正常呼吸频率一般为8～22次/分钟。呼吸过速可能是由于焦虑、发热、心脏疾病等原因引起。\n\n#### 6. 西床颜秀梅（1楼-1层-113房）\n- **事件**：发生2次呼吸过速报警。\n- **具体数据**：\n  - **9月4日**：\n    - 08:18～08:19 发生1次呼吸过速报警。\n    - 10:35～10:36 发生1次呼吸过速报警。\n- **护理措施建议**：\n  - 沟通身体情况。\n  - 进行基础的体温、血压、呼吸、心跳测量。\n- **科普讲解**：\n  - **呼吸过速**：呼吸频率超过设置的报警阈值。成人正常呼吸频率一般为8～22次/分钟。呼吸过速可能是由于焦虑、发热、心脏疾病等原因引起。\n\n#### 7. 南床杨玉兰（1楼-1层-106房）\n- **事件**：入睡时间比日常晚、入睡时长变长。\n- **具体数据**：\n  - **9月4日**：入睡时间为21:54，入睡时长为1小时54分钟。\n- **日常表现与变化**：\n  - **日常入睡时间**：通常为20:00左右。\n  - **9月4日变化**：入睡时间为21:54，比日常晚1小时54分钟。\n  - **日常入睡时长**：通常在0～42分钟之间。\n  - **9月4日变化**：入睡时长为1小时54分钟。\n- **护理措施建议**：\n  - 沟通身体情况。\n  - 了解情绪情况。\n  - 睡前饮食用药情况。\n  - 进行基础的体温、血压、呼吸、心跳测量。\n- **科普讲解**：\n  - **入睡时间比日常晚**：指老人入睡时间比平时延迟，可能与情绪、环境、身体状况等因素有关。\n  - **入睡时长变长**：指老人从准备入睡到真正进入睡眠的时间延长，可能是因为身体不适、心理压力等原因造成。\n\n#### 8. 北6赵吉良（1楼-3层-315房）\n- **事件**：吸呼比变高。\n- **具体数据**：\n  - **9月4日**：吸呼比为1。\n- **日常表现与变化**：\n  - **日常吸呼比**：通常在0.5～0.7之间。\n  - **9月4日变化**：吸呼比为1。\n- **护理措施建议**：\n  - 沟通身体情况。\n  - 进行基础的体温、血压、呼吸、心跳测量。\n- **科普讲解**：\n  - **吸呼比**：指吸气时间与呼气时间的比例，一般情况下正常人的吸呼比集中在0.8～1.5之间。吸呼比变高可能提示存在呼吸系统问题，如冠心病、慢阻肺、哮喘等。',
	  displayedContent: '',
	  interval1: null,
	  index: 1

    };
  },
  computed: {
  },
  created() {
	let _this = this;
	document.addEventListener('custom-event-1', function(e) {
		_this.isTip = true;
		_this.tipType = 1;
		console.log(e.detail); // 输出: 'value'
	});
  },
  mounted() {
    this.tenantId = this.$getCookie('userInfo').user.tenantId;
    this.getHealthBigData();


    // this.getHomeDate()          //获取首页报警事件接口
    // this.getHomeTopList()       //查看首页排行榜接口

	this.getHomeDataFirst();
	this.getHomeDataSecond();
	// this.getHomeDataThird();
	this.getHomeRankingListData();

	this.getHomeNewVersion();


  },
  methods: {
	// 转换为二维数组 - 每行5个元素
	convertTwoDimensionalArray(arr) {
		if (!arr || arr.length == 0) {
			return
		}
		let needArr = [];
		for (let i = 0; i < arr.length; i += 5) {
			needArr.push(arr.slice(i, i + 5));
		}
		return needArr;
	},
	// 获取新功能引导
	getHomeNewVersion() {
		this.$get(
        'api/dean/v5/newVersionDesc',
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
				if (res.data.isPopup) {
					this.isTip = true;
					this.tipType = 1;
				}
				document.dispatchEvent(new CustomEvent('custom-event-2', { detail: res.data.isShow }));
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
	},
	// 当日需及时关心的长者
	getHomeDataFirst() {
		this.$get(
        'api/dean/v5/timelyCareElderList',
        {},
        (res) => {
// 			res = {
//     "code": 0,
//     "msg": null,
//     "data": {
//         "timelyCareElderTips": "",
//         "timelyCareElderVoList": [
//             {
//                 "bedId": 1226,
//                 "bedName": "V8测试-2层-房间3-C8F09E282A6C",
//                 "eventList": [
//                     "发生40次离床过久报警",
//                     "入睡时间比日常晚、入睡时长变长"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>40</Text_R>次离床过久报警",
//                     "入睡时间比日常<Text_R>晚</Text_R>、入睡时长<Text_R>变长</Text_R>"
//                 ]
//             },
//             {
//                 "bedId": 1216,
//                 "bedName": "V8测试-2层-房间1-C8F09E286C20",
//                 "eventList": [
//                     "发生28次离床过久报警",
//                     "多次起夜"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>28</Text_R>次离床过久报警",
//                     "<Text_R>多次</Text_R>起夜"
//                 ]
//             },
//             {
//                 "bedId": 1221,
//                 "bedName": "V8测试-2层-房间2-C8F09E2859FC",
//                 "eventList": [
//                     "发生7次离床过久报警",
//                     "入睡时间比日常晚、入睡时长变长"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>7</Text_R>次离床过久报警",
//                     "入睡时间比日常<Text_R>晚</Text_R>、入睡时长<Text_R>变长</Text_R>"
//                 ]
//             },
//             {
//                 "bedId": 1213,
//                 "bedName": "V8测试-2层-房间1-782184C42F5C",
//                 "eventList": [
//                     "发生34次离床过久报警"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>34</Text_R>次离床过久报警"
//                 ]
//             },
//             {
//                 "bedId": 1230,
//                 "bedName": "V8测试-2层-房间4-C049EFBBFD2C",
//                 "eventList": [
//                     "发生35次离床过久报警",
//                     "睡眠破碎"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>35</Text_R>次离床过久报警",
//                     "睡眠<Text_R>破碎</Text_R>"
//                 ]
//             },
//             {
//                 "bedId": 1253,
//                 "bedName": "V8测试-2层-房间8-349454360B64-V7",
//                 "eventList": [
//                     "发生13次呼吸过速报警"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>13</Text_R>次呼吸过速报警"
//                 ]
//             },
//             {
//                 "bedId": 1054,
//                 "bedName": "V8测试-2层-房间9-实时报警测试（陈思亮）-782184C44848-V7",
//                 "eventList": [
//                     "发生2次离床过久报警"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>2</Text_R>次离床过久报警"
//                 ]
//             },
//             {
//                 "bedId": 1229,
//                 "bedName": "V8测试-2层-房间4-C8F09E287120",
//                 "eventList": [
//                     "发生16次离床过久报警",
//                     "入睡时长变长"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>16</Text_R>次离床过久报警",
//                     "入睡时长<Text_R>变长</Text_R>"
//                 ]
//             },
//             {
//                 "bedId": 1227,
//                 "bedName": "V8测试-2层-房间3-C8F09E2872B0",
//                 "eventList": [
//                     "发生3次离床过久报警"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>3</Text_R>次离床过久报警"
//                 ]
//             },
//             {
//                 "bedId": 1220,
//                 "bedName": "V8测试-2层-房间2-782184C621F4",
//                 "eventList": [
//                     "发生9次离床过久报警"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>9</Text_R>次离床过久报警"
//                 ]
//             },
//             {
//                 "bedId": 1223,
//                 "bedName": "V8测试-2层-房间3-C8F09E286F14",
//                 "eventList": [
//                     "发生34次离床过久报警"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>34</Text_R>次离床过久报警"
//                 ]
//             },
//             {
//                 "bedId": 1247,
//                 "bedName": "V8测试-2层-房间7-4022D87CF658",
//                 "eventList": [
//                     "发生24次离床过久报警"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>24</Text_R>次离床过久报警"
//                 ]
//             },
//             {
//                 "bedId": 1224,
//                 "bedName": "V8测试-2层-房间3-C049EFBBFBA4",
//                 "eventList": [
//                     "发生3次离床过久报警"
//                 ],
//                 "eventTextList": [
//                     "发生<Text_R>3</Text_R>次离床过久报警"
//                 ]
//             },
//             {
//                 "bedId": 1231,
//                 "bedName": "V8测试-2层-房间4-4022D87CDE54",
//                 "eventList": [
//                     "吸呼比变低"
//                 ],
//                 "eventTextList": [
//                     "吸呼比<Text_R>变低</Text_R>"
//                 ]
//             },
//             {
//                 "bedId": 1041,
//                 "bedName": "V8测试-2层-房间8-C4DEE20D2280-V7",
//                 "eventList": null,
//                 "eventTextList": null
//             }
//         ]
//     }
// }
          if (res.code == 0) {
            if (res.data) {
			  this.firstCardDict = res.data;
			  this.firstCardDataLength = res.data.timelyCareElderVoList ? res.data.timelyCareElderVoList.length : 0;
              this.firstCardData = this.convertTwoDimensionalArray(res.data.timelyCareElderVoList);
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
	},
	// 需要长期观察的长者
	getHomeDataSecond() {
		this.$get(
        'api/dean/v5/longObserveElderList',
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
			  this.secondCardDict = res.data;
			  this.secondCardDataLength = res.data.longObserveElderVoList ? res.data.longObserveElderVoList.length : 0;
              this.secondCardData = this.convertTwoDimensionalArray(res.data.longObserveElderVoList);
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
		
        }
      );
	},
	// 状态优秀的长者
	getHomeDataThird() {
		this.$get(
        'api/dean/v5/stateExcellentElderList',
        {},
        (res) => {
			// res = thirdCardMockData;
          if (res.code == 0) {
            if (res.data) {
			  this.thirdCardDataLength = res.data.length;
              this.thirdCardData = this.convertTwoDimensionalArray(res.data);
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
	},
	// 当日需及时关心的长者
	getHomeRankingListData() {
		this.$get(
        'api/dean/v5/rankingList',
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
				this.rankingListData = res.data;
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
	},
    // 获取首页报警事件接口
    getHomeDate(){
      // this.bjAllData = dataJson.data
      this.$get(
        'api/v4/home/getHomeDate',
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.bjAllData = res.data
              
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
    },
    // 查看首页排行榜接口
    getHomeTopList(){
      this.$get(
        'api/v4/home/getHomeTopList',
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.rankListData = res.data
              
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
    },
	


    getHealthBigData() {
      this.$post(
        'api/health-big-data/select',
        {
          tenantId: this.tenantId,
        },
        (res) => {
          if (res.code == 0) {
            if (res.data) {
              this.healthBigData = res.data;
            } else {
            }
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
    },
    // 查看详情
    details(scope, pageName) {
      this.$refs.healthy.details({
        bedId: scope.bedId,
        bedName: scope.bedName,
        activeType: scope.activeType,
        activeDate: scope.activeDate,
        sn: scope.sn,
      }, pageName);
    },
    tabClick2(type) {
      Global.$emit('tabClick2', {
        type: type,
      });
    },


    // 打开关注老人单日详情弹窗
    open_tan_needGZ_single(data){
      this.$refs.tan_needGz_sin.openComponent(data)
    },

	// 跳过教程 ｜ 再看一遍
	skippingTutorial(type) { // type： 1-卡片1 2-卡片2 3-卡片3
		if (type == 1) { // 跳过教程
			this.isTip = false;
			this.tipType = 0;
		} else if (type == 2) { // 跳过教程
			this.isTip = false;
			this.tipType = 0;
		} else if (type == 3) { // 再看一遍
			this.isTip = true;
			this.tipType = 1;
		}
		this.noPromptNewVersion();
	},
	// 下一步 ｜ 我知道了
	next(type, isNotTip) { // type： 1-卡片1 2-卡片2 3-卡片3
		if (type == 1) {
			this.tipType = 2;
		} else if (type == 2) {
			this.tipType = 3;
		} else if (type == 3) {
			if (isNotTip == true) { // 不再提示
				this.noPromptNewVersion();
			} else {

			}
			this.isTip = false;
			this.tipType = 0;
		}
	},
	// 查看5.0新版本说明
	lookNewVersionExplain() {
	},
	noPromptNewVersion() {
		this.$get(
        'api/dean/v5/guidePopupIgnore',
        {},
        (res) => {
          if (res.code == 0) {
            if (res.data) {
				
            } 
          } else {
            this.$message.error(res.msg);
          }
        },
        (err) => {
          console.log(err);
          this.$message.error('服务端发生异常');
        }
      );
	}







  },
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/comHome.scss';
.home {
  width: 1200px;
  user-select: none;
  padding-bottom: 100px;
}

</style>

<style>

</style>
